import { ObjectField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class TubularPitchEnvelope extends ObjectField {
    static create(construct) {
        return new TubularPitchEnvelope(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get rate1() {
        return this.getField(1);
    }
    get rate2() {
        return this.getField(2);
    }
    get rate3() {
        return this.getField(3);
    }
    get rate4() {
        return this.getField(4);
    }
    get level1() {
        return this.getField(11);
    }
    get level2() {
        return this.getField(12);
    }
    get level3() {
        return this.getField(13);
    }
    get level4() {
        return this.getField(14);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "rate1",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "rate2",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "rate3",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            4: Int32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "rate4",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "level1",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 50),
            12: Int32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "level2",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 50),
            13: Int32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "level3",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 50),
            14: Int32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "level4",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 50),
        };
    }
}
